import AuctionCardNFT from "Component/AuctionCard/AuctionCard";
import Footer from "Component/Footer/Footer";
import Header from "Component/Header/Header";
import TopMuseumsNFT from "Component/TopMuseum/TopMuseums";
import TrandingArtist from "Component/TrandingArtist/TransingArtist";
import Blogsection from "Pages/Home/Blogsection";
import DigitalArtcollection from "Pages/Home/DigitalArtcollection";
import Homebanner from "Pages/Home/Homebanner";
import BrowseByCategory from "Pages/Home/Upcomingauction";
import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Input } from "reactstrap";
import CategoryCard from "./categoryCard";

export default function Category(props) {
  const { HideData, getLikedPost, isLiked } = props;
  const { categories } = useSelector((state) => state?.categories);
  const [state, setState] = useState("all");

  const [filter, setfilter] = useState({
    limit: 8,
    orderBy: "_id",
    order: -1,
    page: 1,
    collectedAuthor: "",
    author: "",
    createdAuthor: "",
    collectionId: "",
    fields: [],
    fileType: [],
    isVarified: false,
    getNew: false,
    isMore: false,
  });
  const data = [
    { image: 'images/newpng/img1.png', name: 'Capturing coat', price: '', discription: 'Origin Story is partnered with top collections such as Pudgy Penguins.' },
    { image: 'images/newpng/img2.png', name: 'Against the grain', price: '', discription: 'Origin Story is partnered with top collections such as Pudgy Penguins.' },
    { image: 'images/newpng/img3.png', name: 'Jewels of the Auction', price: '', discription: 'Origin Story is partnered with top collections such as Pudgy Penguins.' },
    { image: 'images/newpng/img4.png', name: 'Racing-the-storm', price: '', discription: 'Origin Story is partnered with top collections such as Pudgy Penguins.' }
  ]


  return (
    <div className="position-relative">
      <Header />
      <div className="gradientBg">
        <div className="container-fluid profileBox dashboardprofile">
          <Row>
            <Col lg={12}>
              <h1>&nbsp;</h1>
            </Col>
          </Row>
        </div>
        <section className="upcoming-section browseCategory position-relative">
          <Container>
            <Row>
              {/* <Col lg={12}>
                <Row className="justify-content-center">
                  <Col lg={7}>
                    <div className="catesearch position-relative">
                      <Input
                        className="categorySearch"
                        placeholder="Search..."
                      />
                      <button>
                        <i className="fa-light fa-magnifying-glass"></i>
                      </button>
                    </div>
                  </Col>
                </Row>
              </Col> */}
              <Col lg={12}>
                <div className="DigitalArtcollection-head currentauction-head d-flex align-items-center justify-content-center mb-5">
                  <div className="text-center">
                    <h2>Category</h2>
                    <p>Explore The Digital Artworks In The Most Featured Categories</p>
                  </div>
                </div>
                <div className="categoryBox mt-4">
                  <div className="Boxin1 art active">
                    <div className="contBox">
                      <div className="imgBox">
                        <img src={"images/svg/cate_art.svg"} alt=""></img>
                      </div>
                      <h3>Traditional Art</h3>
                    </div>
                  </div>
                  {/* <div className="Boxin1 landscape">
                    <div className="contBox">
                      <div className="imgBox">
                        <img src={"images/svg/cate_landscape.svg"} alt=""></img>
                      </div>
                      <h3>Landscape </h3>
                    </div>
                  </div>
                  <div className="Boxin1 sport ">
                    <div className="contBox">
                      <div className="imgBox">
                        <img src={"images/png/stilllife.png"} alt=""></img>
                      </div>
                      <h3>Still Life</h3>
                    </div>
                  </div> */}
                  <div className="Boxin1 cryptopunks">
                    <div className="contBox">
                      <div className="imgBox">
                        <img src={"images/svg/camera.svg"} alt=""></img>
                      </div>
                      <h3>Photography</h3>
                    </div>
                  </div>
                  {/* <div className="Boxin1 cubism">
                    <div className="contBox">
                      <div className="imgBox">
                        <img src={"images/svg/cate_cubism.svg"} alt=""></img>
                      </div>
                      <h3>Abstract</h3>
                    </div>
                  </div>

                  <div className="Boxin1 utility ">
                    <div className="contBox">
                      <div className="imgBox">
                        <img src={"images/svg/wildlife.svg"} alt=""></img>
                      </div>
                      <h3>Wildlife</h3>
                    </div>
                  </div> */}
                </div>
              </Col>
            </Row>

            {/* <div className="currenta-auction-slider">
          <Slider {...settings}>
            {categories &&
              categories?.length > 0 &&
              categories.map((item, idx) => {
                return (
                  <div key={idx}>
                    <div className="digital-art-wrap upcomimg-aution">
                      <Link to={`/shop?value=${item?._id}`}>
                        <div className="currentlive-art-img position-relative">
                          <img
                            src={
                              item?.image?.link || "images/Currentlive01.png"
                            }
                            alt=""
                            className="img-fluid home-cate"
                          />
                        </div>
                      </Link>
                      <div className="upcomimg-art-content">
                        <div className="user-partwrap">
                          <div className="user-part">
                            <h3>{item?.name}</h3>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
          </Slider>
        </div> */}
          </Container>
        </section>
      </div>
      <section className="DigitalArtcollection-main position-relative pb-5">
        <Container>
          <Row>
            <Col lg={12}>
              <div className="DigitalArtcollection-head">
                <h2>Collect Digital Art </h2>
                <p>Explore The Digital Artworks In The Most Featured Categories</p>
              </div>
            </Col>
            <Col lg={12}>
              <div className="digitailart-tabbing digitalartsNew  ">
                <div className="tab-frame mt-4 mb-4">
                  {!HideData && (
                    <>
                      {categories && categories?.length > 0 && (
                        <>
                          <div className="filterbox">
                            <input
                              name="tab"
                              type="radio"
                              checked={state === "all"}
                            />
                            <label
                              onClick={() => {
                                setState("all");
                                setfilter((prev) => ({
                                  ...prev,
                                  category: [],
                                }));
                              }}
                            >
                              All
                            </label>

                            {categories?.map((categoryItems, id) => {
                              return (
                                <>
                                  <input
                                    key={id}
                                    type="radio"
                                    name="tab"
                                    checked={state === categoryItems?.name}
                                  />
                                  <label
                                    onClick={() => {
                                      setState(categoryItems?.name);
                                      setfilter((prev) => ({
                                        ...prev,
                                        category: [categoryItems?._id],
                                      }));
                                    }}
                                  >
                                    {categoryItems?.name}
                                  </label>
                                </>
                              );
                            })}
                          </div>
                        </>
                      )}
                    </>
                  )}


                </div>
                <Row>
                  {data?.map((nftData, idx) => {
                    return (
                      <Col key={idx} lg={3}>
                        <CategoryCard data={nftData} />
                      </Col>
                    )
                  })}





                </Row>
                {/* <div className="artBoxNew">
              <div className="artItemBoxNew">
                <div className="imgBox">
                  <img className="img-fluid" src={'images/svg/artImg.svg'} alt="" />
                </div>
                <div className="contBox">
                <div className="arthead">
                  <h2 className="productName">Catsmoke #39</h2>
                  <h2 className="productPrice">$ 2.5</h2>

                </div>
                <p>Origin Story is partnered with top collections such as Pudgy Penguins.</p>
              </div>
              </div>
              
            </div> */}
              </div>

              {/* {explore?.length >= 8 && (
        <div className="text-center show-wrap">
          <Link className="link-text" to="/shop">
            <Button className="showmore"> See All Items </Button>
          </Link>
        </div>
      )} */}
            </Col>
          </Row>
        </Container>
      </section>

      <Footer />
    </div>
  );
}
